import React, { useState, useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaCertificate, FaGraduationCap, FaBook, FaChevronDown, FaChevronRight } from 'react-icons/fa';

const Certificaciones = () => {
  const [expandedCourse, setExpandedCourse] = useState(null);

  // Reset scroll position when component mounts
  useEffect(() => {
    // Force scroll to top in multiple ways to ensure it works
    window.scrollTo(0, 0);
    
    // Also try to do it after a small delay 
    setTimeout(() => {
      window.scrollTo(0, 0);
      
      // If we have access to document body, also try to reset its scroll
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      // If we have access to document documentElement (html), also reset its scroll
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
    }, 0);
  }, []);

  const toggleCourse = (index) => {
    if (expandedCourse === index) {
      setExpandedCourse(null);
    } else {
      setExpandedCourse(index);
    }
  };

  const courses = [
    {
      id: 1,
      title: "CURSO ESTÁNDAR OPUS MÓDULO 1",
      description: "Curso básico para aprender los fundamentos del módulo de presupuesto programable.",
      topics: [
        "Interfaz y navegación del sistema",
        "Creación y configuración de presupuestos",
        "Catálogos de insumos",
        "Análisis de precios unitarios",
        "Generación de reportes básicos"
      ]
    },
    {
      id: 2,
      title: "CURSO AVANZADO OPUS MÓDULO 1",
      description: "Curso especializado en características avanzadas del módulo de presupuesto programable.",
      topics: [
        "Manejo de bases de datos de precios",
        "Presupuestos paramétricos",
        "Explosión de insumos",
        "Análisis de rendimientos",
        "Reportes personalizados",
        "Integración con Excel"
      ]
    },
    {
      id: 3,
      title: "CURSO ESTÁNDAR OPUS MÓDULO 2",
      description: "Curso básico para aprender los fundamentos del módulo de planeación y control integral.",
      topics: [
        "Programación de obra",
        "Diagramas de Gantt",
        "Ruta crítica",
        "Asignación de recursos",
        "Seguimiento de avance de obra"
      ]
    },
    {
      id: 4,
      title: "CURSO AVANZADO OPUS MÓDULO 2",
      description: "Curso especializado en características avanzadas del módulo de planeación y control integral.",
      topics: [
        "Técnicas avanzadas de programación",
        "Análisis de valor ganado",
        "Nivelación de recursos",
        "Reprogramación de actividades",
        "Informes de desempeño",
        "Análisis de escenarios"
      ]
    },
    {
      id: 5,
      title: "CURSO ESTÁNDAR OPUS MÓDULO 3",
      description: "Curso básico para aprender los fundamentos del módulo de administración de compras.",
      topics: [
        "Requisiciones de materiales",
        "Órdenes de compra",
        "Control de almacén",
        "Administración de proveedores",
        "Estimaciones y pagos"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Certificaciones OPUS | ECOSOFT"
        description="Obtenga las certificaciones oficiales de OPUS y conviértase en un experto en ingeniería de costos con respaldo profesional."
        name="Certificaciones"
        type="website"
      />
      
      {/* Hero Section */}
      <section className="relative h-[350px] bg-gradient-to-r from-[#003171] to-[#0066CC]">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-14 relative z-10">
          <div className="max-w-2xl text-white">
            <h1 className="text-5xl font-bold mb-4">Certificaciones OPUS</h1>
            <p className="text-xl mb-6">
              Valide sus conocimientos en OPUS y obtenga el respaldo oficial de ECOSOFT para destacar en el mercado laboral.
            </p>
            <div className="flex items-center text-lg">
              <span className="text-white/80">certificacion@ecosoft.com.mx</span>
            </div>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold mb-4 text-[#1A2B39]">El momento es ahora</h2>
            <p className="text-gray-600 text-lg">
              Obtener una certificación ECOSOFT proporciona las destrezas relevantes para una carrera satisfactoria en ingeniería de costos.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaCertificate className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Relevancia</h3>
              <p className="text-gray-600">
                El examen de la certificación de ECOSOFT se evalúa y actualiza periódicamente para garantizar su relevancia en el mercado.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaCheckCircle className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Conocimiento avalado</h3>
              <p className="text-gray-600">
                Su certificación valida sus habilidades y conocimientos en el uso de OPUS, demostrando su capacidad profesional.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaGraduationCap className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Red de instrucción</h3>
              <p className="text-gray-600">
                Acceda a toda una red de Instructores Certificados y Centros de Entrenamiento ECOSOFT en la República Mexicana y el extranjero.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Temarios Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto mb-12">
            <h2 className="text-3xl font-bold mb-4 text-[#1A2B39] text-center">Temarios Oficiales</h2>
            <p className="text-gray-600 text-center mb-8">
              Conozca los temarios oficiales de los cursos y certificaciones OPUS.
            </p>
            
            <div className="space-y-4">
              {courses.map((course, index) => (
                <div key={course.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <div 
                    className="p-4 flex justify-between items-center cursor-pointer hover:bg-gray-50"
                    onClick={() => toggleCourse(index)}
                  >
                    <div className="flex items-center">
                      <div className="w-10 h-10 bg-[#0066CC]/10 rounded-full flex items-center justify-center mr-4">
                        <FaBook className="text-[#0066CC]" />
                      </div>
                      <h3 className="font-bold text-lg text-[#1A2B39]">{course.title}</h3>
                    </div>
                    <div>
                      {expandedCourse === index ? (
                        <FaChevronDown className="text-[#0066CC]" />
                      ) : (
                        <FaChevronRight className="text-[#0066CC]" />
                      )}
                    </div>
                  </div>
                  
                  {expandedCourse === index && (
                    <div className="p-4 border-t border-gray-100">
                      <p className="text-gray-600 mb-4">{course.description}</p>
                      <h4 className="font-semibold mb-2 text-[#1A2B39]">Temas principales:</h4>
                      <ul className="space-y-1 pl-5 list-disc text-gray-600">
                        {course.topics.map((topic, i) => (
                          <li key={i}>{topic}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* Process Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold mb-4 text-[#1A2B39]">Proceso de Certificación</h2>
            <p className="text-gray-600">
              Conozca los pasos para obtener su certificación oficial OPUS.
            </p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md text-center relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#0066CC] text-white flex items-center justify-center font-bold">
                1
              </div>
              <h3 className="text-lg font-bold mb-3 mt-4 text-[#1A2B39]">Capacitación</h3>
              <p className="text-gray-600 text-sm">
                Tome los cursos preparatorios para el módulo en el que desea certificarse
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#0066CC] text-white flex items-center justify-center font-bold">
                2
              </div>
              <h3 className="text-lg font-bold mb-3 mt-4 text-[#1A2B39]">Registro</h3>
              <p className="text-gray-600 text-sm">
                Regístrese para un examen de certificación con un Centro Autorizado
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#0066CC] text-white flex items-center justify-center font-bold">
                3
              </div>
              <h3 className="text-lg font-bold mb-3 mt-4 text-[#1A2B39]">Evaluación</h3>
              <p className="text-gray-600 text-sm">
                Presente y apruebe el examen teórico-práctico del módulo
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#0066CC] text-white flex items-center justify-center font-bold">
                4
              </div>
              <h3 className="text-lg font-bold mb-3 mt-4 text-[#1A2B39]">Certificado</h3>
              <p className="text-gray-600 text-sm">
                Reciba su certificado oficial con validez internacional
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para certificarse en OPUS?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Contacte con nuestro equipo para obtener más información sobre las certificaciones disponibles y el proceso de registro.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/contacto" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Contactar
            </Link>
            <a 
              href="mailto:certificacion@ecosoft.com.mx" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Enviar correo
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Certificaciones; 